// extracted by mini-css-extract-plugin
export default {"closedRegistrationMessageContainer":"_2-ZCX","closedRegistrationMessage":"_2cfWx"};